import { makeStyles } from '@material-ui/core/styles';

import { RiRobot2Line } from '@remixicon/react';

import { Text } from '@backstage/ui';

import { ResourceNameLink } from '@spotify/confidence-core-react';
import {
  ChatInformationBox,
  SUBAGENT_TOOL_NAME_SUFFIX,
  type ToolGroupEntry,
  createToolExtension,
  parseChildChatName,
} from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';

interface CreateSubagentInput {
  description?: string;
  prompt?: string;
  agent_type?: string;
}

const useStyles = makeStyles({
  label: {
    color: 'var(--bui-fg-secondary)',
  },
  detail: {
    color: 'var(--bui-fg-secondary)',
    marginTop: 'var(--bui-space-1)',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
});

const CreateSubagentToolRenderer = ({ entry }: { entry: ToolGroupEntry }) => {
  const classes = useStyles();
  const input = (entry.input ?? {}) as CreateSubagentInput;
  const description = input.description ?? input.prompt ?? 'Sub-agent task';
  const agentType = input.agent_type;
  const childChatName = parseChildChatName(entry.result?.content);

  return (
    <ChatInformationBox
      icon={<RiRobot2Line size={14} />}
      title={
        <Text variant="body-small" className={classes.label}>
          {childChatName ? (
            <ResourceNameLink name={childChatName} text={description} />
          ) : (
            description
          )}
          {agentType && (
            <span className={classes.label}>{` · ${agentType}`}</span>
          )}
        </Text>
      }
    >
      {input.prompt &&
        input.description &&
        input.prompt !== input.description && (
          <Text variant="body-small" className={classes.detail}>
            {input.prompt}
          </Text>
        )}
    </ChatInformationBox>
  );
};

export const CreateSubagentToolExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'create-subagent',
    predicate: tool => tool.endsWith(SUBAGENT_TOOL_NAME_SUFFIX),
    icon: RiRobot2Line,
    display: 'prominent',
    render: () => null,
    renderTool: entry => <CreateSubagentToolRenderer entry={entry} />,
  }),
);
